module.exports = __webpack_public_path__ + "img/img-evo.d4f13b04.png";